import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'components/base';

import { Panel, Typography } from '../../components/base';

const SelectPanel = props => {
  const handleOnChange = e => {
    props.onChange(e.target.value);
  };

  return (
    <Panel borderColor="orange" className={props.className}>
      <Typography.Heading size={2} mb={3}>
        {props.title}
      </Typography.Heading>
      <Typography.Paragraph mb={3}>{props.description}</Typography.Paragraph>
      <Form.Select value={props.active} onChange={handleOnChange}>
        {props.items.map(item => (
          <Form.SelectOption key={item.id} value={item.id}>
            {item.label}
            {item.description && ` (${item.description})`}
          </Form.SelectOption>
        ))}
      </Form.Select>
    </Panel>
  );
};

SelectPanel.propTypes = {
  active: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  items: PropTypes.array,
  className: PropTypes.string,
  onChange: PropTypes.func,
};

export default SelectPanel;
